export const CONDITION_STEP_UUID = '2fd417b7-e709-5b91-ab83-4fbd9e7f8273';

export const isConditionStep = step =>
  (step?.id ?? step?.uuid) === CONDITION_STEP_UUID;

export const ConditionOperators = {
  EQUALS: 'EQUALS',
  NOT_EQUALS: 'NOT_EQUALS',
  STARTS_WITH: 'STARTS_WITH',
  DOES_NOT_START_WITH: 'DOES_NOT_START_WITH',
  ENDS_WITH: 'ENDS_WITH',
  DOES_NOT_END_WITH: 'DOES_NOT_END_WITH',
  CONTAINS: 'CONTAINS',
  DOES_NOT_CONTAIN: 'DOES_NOT_CONTAIN',
  IS_EMPTY: 'IS_EMPTY',
  IS_NOT_EMPTY: 'IS_NOT_EMPTY',
};

export function isUnaryConditionOperator(conditionOperator) {
  switch (conditionOperator) {
    case ConditionOperators.IS_EMPTY:
    case ConditionOperators.IS_NOT_EMPTY:
      return true;
    default:
  }
  return false;
}

export const ConditionSetOperators = {
  AND: 'AND',
  OR: 'OR',
};

export const CONDITION_OPERAND_MAX_LENGTH = 20000;
